import { Injectable } from '@angular/core';
import {
  IForgotPasswordBody,
  IForgotPasswordResponse,
  ILoginResponse,
  ISignupForm,
  ISignUpResponse,
  IUserBasicInfoResponse,
  IValidateCodeResponse
} from '@models';
import { HttpService } from '../core/http.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ResendVerificationCodeResponseCodesEnum } from '@shared/enums/response-codes.enums';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly API = 'Users';
  constructor(private httpService: HttpService) {}

  public login(user): Promise<ILoginResponse | HttpErrorResponse> {
    return this.httpService.http_post({
      endpoint: 'login',
      body: JSON.stringify(user),
      api: this.API,
      needToken: false
    }) as Promise<ILoginResponse | HttpErrorResponse>;
  }

  public logout(): Promise<number> {
    return this.httpService.http_get({
      endpoint: 'logout',
      api: this.API,
      needToken: true
    }) as Promise<number>;
  }

  public signUp(user: ISignupForm): Promise<ISignUpResponse> {
    return this.httpService.http_post({
      endpoint: 'signup',
      body: JSON.stringify(user),
      api: this.API,
      needToken: false
    }) as Promise<ISignUpResponse>;
  }

  /**
   * @description - Recurepar contraseña
   */
  public resetPassword(formData: IForgotPasswordBody): Promise<IForgotPasswordResponse> {
    return this.httpService.http_post({
      endpoint: 'forgot_password',
      body: JSON.stringify(formData),
      api: this.API,
      needToken: false
    }) as Promise<IForgotPasswordResponse>;
  }

  /**
   * @description - Verificar el codigo que el usuario recibio por SMS o email
   */
  public validateCode(code: string): Promise<IValidateCodeResponse> {
    return this.httpService.http_get({
      endpoint: 'validarCodeSMS',
      param: `?code=${code}`,
      api: this.API,
      needToken: false,
      responseType: 'text'
    }) as Promise<IValidateCodeResponse>;
  }

  /**
   * @description - Obtener datos basicos del usuario, pero a diferencia del login no trae tokens de session
   */
  public getUserBasicInfo(document: string): Promise<IUserBasicInfoResponse> {
    return this.httpService.http_get({
      endpoint: 'getByUsername',
      param: `?username=${document}`,
      api: this.API,
      needToken: false,
      responseType: 'text'
    }) as Promise<IUserBasicInfoResponse>;
  }

  /**
   * @description - Verificar el codigo que el usuario recibio por SMS o email
   */
  public resendValidationCode(
    document: string,
    verificationMethod: 1 | 2
  ): Promise<ResendVerificationCodeResponseCodesEnum | number> {
    return this.httpService.http_get({
      endpoint: 'resendCodeSMS',
      param: `?cedula=${document}&formaVerificacion=${verificationMethod}`,
      api: this.API,
      needToken: false,
      responseType: 'text'
    }) as Promise<ResendVerificationCodeResponseCodesEnum | number>;
  }
}
